import sectionCardStepCss from '../css-snippets/section-card-step';

const html = ` 
<style>${sectionCardStepCss}</style>
<div
  class="card-step-wrapper"
  data-id="unique-id"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div class="card-step-container container" data-position="left">
    <div class="card-step-content">
      <div class="card-step-description">
        <h2>
          <strong>7. The Perfect Gift That's Ready to Play in Seconds</strong>
        </h2>
      </div>
      <div class="card-step-list">
        <div class="card-step-item">
          <div class="card-step-item-number">
            01
          </div>
          <div class="card-step-item-text">
            <p>
              <strong>
                Solves Gift-Giving Anxiety
              </strong>
            </p>
            <p>
              Hypnotic glowing eyes & realistic scuttling spark immediate joy.
            </p>
          </div>
        </div>
        <div class="card-step-item">
          <div class="card-step-item-number">
            02
          </div>
          <div class="card-step-item-text">
            <p>
              <strong>
                Instant Fun, Zero Setup
              </strong>
            </p>
            <p>
              Click. It scurries. Kids and pets chase. Instantly.
            </p>
          </div>
        </div>
        <div class="card-step-item">
          <div class="card-step-item-number">
            03
          </div>
          <div class="card-step-item-text">
            <p>
              <strong>
                Creates Shared Moments & Memories
              </strong>
            </p>
            <p>
              Laughing kids, excited pets, smiling adults—shared memories made.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="card-step-image">
      <img
        src="https://cdn.skyfastimg.com/images/2025/12/15/image-693fb9c1c5731fa85958a6cc.jpg?w=500&h=50&q=80"
        alt="image"
      />
    </div>
  </div>
</div>
`;

export default html;
